export function normalizeFusionInfoToStore(input) {
  const mapping = {
    FUSION_AV: 'av',
    FUSION_MV: 'mv',
    FUSION_BV: 'bv',
    1: 'av',
    2: 'mv',
    3: 'bv',
  };
  return mapping[input] || input;
}